import { styled } from '@mui/material/styles';
import { Box, Link } from '@mui/material';
import _TwitterIcon from '@/assets/images/icons/prime_twitter.svg?react';
import _TelegramIcon from '@/assets/images/icons/telegram_simple_icon.svg?react';
import _DiscordIcon from '@/assets/images/icons/discord_icon.svg?react';
import _YoutubeIcon from '@/assets/images/icons/youtube_icon.svg?react';

export const FooterWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    padding: '10px 40px',
    backgroundColor: theme.palette.primitives.woodsmoke[1000],
    zIndex: 10,
    gap: '12px',
    borderStyle: 'solid',
    borderColor: theme.palette.divider,
    borderBottomWidth: '1px',
    borderTopWidth: '1px',

    [theme.breakpoints.down('md')]: {
        border: 'none',
        padding: 0,
        justifyContent: 'center',
        gap: '16px',
    },
}));

export const SocialButton = styled(Link)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    textAlign: 'center',
    marginTop: '2px',
}));

export const YoutubeIcon = styled(_YoutubeIcon)(({ theme }) => ({
    width: '14px',
    height: '14px',

    '&:hover': {
        path: { fill: theme.palette.hyperLiquidColor2 },
    },
}));
export const TwitterIcon = styled(_TwitterIcon)(({ theme }) => ({
    width: '12px',
    height: '12px',

    '&:hover': {
        path: { fill: theme.palette.hyperLiquidColor2 },
    },
}));
export const TelegramIcon = styled(_TelegramIcon)(({ theme }) => ({
    width: '14px',
    height: '14px',

    '&:hover': {
        path: { fill: theme.palette.hyperLiquidColor2 },
    },
}));

export const DiscordIcon = styled(_DiscordIcon)(({ theme }) => ({
    width: '16px',
    height: 'auto',

    '&:hover': {
        path: { fill: theme.palette.hyperLiquidColor2 },
    },
}));
